import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_HOST_API + '/api/broadcast-log',
  withCredentials: true,
  headers: {
    Accept: 'application/json',
  },
})

export default {
  confirm(broadcastToken, socketId) {
    return apiClient.post('/confirm', {
      broadcast_token: broadcastToken,
      socket_id: socketId,
    })
  },
}
